import React, { Component } from 'react';
import moment from 'moment';

import Modal from 'react-bootstrap/Modal';

import './ImageModal.scss';

class ImageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      loading: true,
      loadedUrls: {},
      showLoading: false
    };
    this.loadingTimer = null;
  }

  componentWillUnmount() {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  }

  setLoadingState = isLoading => {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    if (isLoading) {
      this.setState({ loading: true, showLoading: false });
      this.loadingTimer = setTimeout(() => {
        this.setState({ showLoading: true });
      }, 200);
    } else {
      this.setState({ loading: false, showLoading: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      const initialIndex = this.getInitialIndex(this.props.data);
      const images = this.getImages(this.props.data);
      const initialUrl =
        images.length > 0 && images[initialIndex]
          ? images[initialIndex].url
          : null;
      const payloadLoading = Boolean(
        this.props.data && this.props.data.loading
      );
      this.setState(
        state => ({
          currentIndex: initialIndex
        }),
        () =>
          this.setLoadingState(
            payloadLoading ||
              (initialUrl ? !this.state.loadedUrls[initialUrl] : false)
          )
      );
    }

    if (prevProps.data !== this.props.data && this.props.open) {
      const initialIndex = this.getInitialIndex(this.props.data);
      const images = this.getImages(this.props.data);
      const initialUrl =
        images.length > 0 && images[initialIndex]
          ? images[initialIndex].url
          : null;
      const payloadLoading = Boolean(
        this.props.data && this.props.data.loading
      );
      this.setState(
        state => ({
          currentIndex: initialIndex
        }),
        () =>
          this.setLoadingState(
            payloadLoading ||
              (initialUrl ? !this.state.loadedUrls[initialUrl] : false)
          )
      );
    }
  }

  normalizeIndex = (index, length) => {
    const size = Number(length) || 0;
    if (size <= 0) return 0;
    const numericIndex = Number(index);
    const safeIndex = Number.isFinite(numericIndex) ? numericIndex : 0;
    return ((safeIndex % size) + size) % size;
  };

  getInitialIndex = data => {
    if (!data) return 0;
    return Number.isInteger(data.index) ? data.index : 0;
  };

  getImages = data => {
    if (data && Array.isArray(data.images) && data.images.length > 0) {
      return data.images;
    }
    if (data && (data.Media || data.url)) {
      return [data];
    }
    return [];
  };

  goPrev = images => {
    if (!images.length) return;
    const currentIndex = this.normalizeIndex(
      this.state.currentIndex,
      images.length
    );
    const nextIndex = this.normalizeIndex(currentIndex - 1, images.length);
    const nextUrl = images[nextIndex] ? images[nextIndex].url : null;
    this.setState({ currentIndex: nextIndex });
    this.setLoadingState(nextUrl ? !this.state.loadedUrls[nextUrl] : true);
  };

  goNext = images => {
    if (!images.length) return;
    const currentIndex = this.normalizeIndex(
      this.state.currentIndex,
      images.length
    );
    const nextIndex = this.normalizeIndex(currentIndex + 1, images.length);
    const nextUrl = images[nextIndex] ? images[nextIndex].url : null;
    this.setState({ currentIndex: nextIndex });
    this.setLoadingState(nextUrl ? !this.state.loadedUrls[nextUrl] : true);
  };

  render() {
    const { ...props } = this.props;
    const payloadLoading = Boolean(props.data && props.data.loading);
    const images = this.getImages(props.data);
    const currentIndex = this.normalizeIndex(
      this.state.currentIndex,
      images.length
    );
    const current = images.length > 0 ? images[currentIndex] : null;
    const mediaName = payloadLoading
      ? 'Loading media...'
      : current && current.Media
      ? current.Media.name
      : '';
    const mediaWhen =
      current && current.Media
        ? moment(current.Media.when).format('DD MMM YYYY - HH:mm')
        : '';

    return (
      <Modal show={props.open} onHide={props.close}>
        <Modal.Header closeButton>
          <div className="image-modal-header" id="exampleModalLabel">
            <span className="image-modal-header-secondary">{mediaName}</span>
            {mediaWhen && (
              <span className="image-modal-header-primary">{` - ${mediaWhen}`}</span>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="image-modal-body">
            {images.length > 1 && (
              <button
                type="button"
                className="image-nav image-nav-left"
                onClick={() => this.goPrev(images)}
                aria-label="Previous image"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </button>
            )}
            {current && (
              <img
                src={current.url}
                className="img-fluid"
                alt=""
                onLoad={() =>
                  this.setState(
                    state => ({
                      loadedUrls: { ...state.loadedUrls, [current.url]: true }
                    }),
                    () => this.setLoadingState(false)
                  )
                }
                onError={() => this.setLoadingState(false)}
              />
            )}
            {payloadLoading && (
              <div className="image-loading">
                <span className="spinner-border mr-2" aria-hidden="true" />
                <span>Loading image...</span>
              </div>
            )}
            {this.state.showLoading && current && (
              <div className="image-loading">Loading image</div>
            )}
            {!payloadLoading && !current && (
              <div className="image-loading">No image available</div>
            )}
            {images.length > 1 && (
              <button
                type="button"
                className="image-nav image-nav-right"
                onClick={() => this.goNext(images)}
                aria-label="Next image"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chevron-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </button>
            )}
          </div>

          <div className="pt-3">
            {/* <span className="badge badge-secondary p-2 mr-1 mb-1 text-uppercase">Reptile</span>
                    <span className="badge badge-secondary p-2 mr-1 mb-1 text-uppercase">Female</span>
                    <span className="badge badge-secondary p-2 mr-1 mb-1 text-uppercase">Adult</span> */}

            <span
              type="button"
              className="btn btn-outline-primary btn-sm float-right d-none"
              data-toggle="collapse"
              href="#multiCollapseExample2"
              role="button"
              aria-expanded="false"
              aria-controls="multiCollapseExample1"
            >
              JPG
              <svg
                className="bi bi-download ml-1"
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http:www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M.5 8a.5.5 0 01.5.5V12a1 1 0 001 1h12a1 1 0 001-1V8.5a.5.5 0 011 0V12a2 2 0 01-2 2H2a2 2 0 01-2-2V8.5A.5.5 0 01.5 8z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M5 7.5a.5.5 0 01.707 0L8 9.793 10.293 7.5a.5.5 0 11.707.707l-2.646 2.647a.5.5 0 01-.708 0L5 8.207A.5.5 0 015 7.5z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M8 1a.5.5 0 01.5.5v8a.5.5 0 01-1 0v-8A.5.5 0 018 1z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ImageModal;
